<df-shared-lib-image-upload-cropper
    [isDialog]="true"
    [isLoading]="loading"
    [roundCropper]="true"
    (uploadFormData)="updateProfilePicture($event)">
</df-shared-lib-image-upload-cropper>
